import React, { Component, Fragment } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'redux';

import Header from 'components/shared/Header';
import MenuItem from 'material-ui/MenuItem';

import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import OutlinedSelect from 'helpers/reduxFormMaterialUiNext/OutlinedSelect';
import { onlyNumbers, createTimeRange } from 'helpers/Formatter';
import * as validator from 'helpers/Validator';
import { getTranslatedString } from 'helpers/i18n';
import range from 'lodash/range';
import { hostIsCapreit } from 'helpers/CurrentWindowLocation';

import AmenityCalendarHold from './CalendarHolds/AmenityCalendarHold';
import { RenderIfToggleOn } from 'components/shared/ToggleRenderer';

const styles = {
  tableWrapper: {
    position: 'relative',
  },
};
class AmenityRestrictionsForm extends Component {
  render() {
    return (
      <Fragment>
        <div style={styles.tableWrapper}>
          <RenderIfToggleOn toggle="ui.amenities.calendar_holds">
            <AmenityCalendarHold amenity={this.props.amenity} />
          </RenderIfToggleOn>

          <Header
            name={getTranslatedString('landlordPortal.amenities.restrictions.header').toUpperCase()}
          />
          <div className="row" style={{ padding: '15px' }}>
            <p style={{ textAlign: 'justify' }}>
              {getTranslatedString('landlordPortal.amenities.restrictions.details')}
            </p>
            <div className="col-xs-6" style={{ paddingLeft: 0 }}>
              <Field
                name="max_number_of_bookings"
                component={TextField}
                normalize={onlyNumbers}
                label={getTranslatedString(
                  'landlordPortal.amenities.restrictions.numberOfBookings'
                )}
                multiLine
                fullWidth
                style={{ fontSize: '15px' }}
                variant="outlined"
              />
            </div>
            <div className="col-xs-6" style={{ paddingRight: 0 }}>
              <Field
                name="booking_restriction_timeframe"
                component={OutlinedSelect}
                fullWidth
                variant="outlined"
                label={getTranslatedString('landlordPortal.amenities.restrictions.frequency')}
                style={{ fontSize: '14px' }}
              >
                <MenuItem value={'week'}>
                  {getTranslatedString('landlordPortal.amenities.restrictions.frequency.perWeek')}
                </MenuItem>
                <MenuItem value={'month'}>
                  {getTranslatedString('landlordPortal.amenities.restrictions.frequency.perMonth')}
                </MenuItem>
                <MenuItem value={'year'}>
                  {getTranslatedString('landlordPortal.amenities.restrictions.frequency.perYear')}
                </MenuItem>
              </Field>
            </div>
          </div>
          <div className="row" style={{ padding: '15px' }}>
            <p style={{ textAlign: 'justify' }}>
              {getTranslatedString('landlordPortal.amenities.capacityRestrictions.details')}
            </p>
            <div className="col-xs-12" style={{ paddingLeft: 0 }}>
              <Field
                name="amenity_capacity"
                component={TextField}
                normalize={onlyNumbers}
                label={getTranslatedString('landlordPortal.amenities.restrictions.capacity')}
                multiLine
                fullWidth
                style={{ fontSize: '15px' }}
                variant="outlined"
              />
            </div>
          </div>
          <Header
            name={getTranslatedString(
              'landlordPortal.amenities.restrictions.hotZone'
            ).toUpperCase()}
          />
          <div className="row" style={{ padding: '15px' }}>
            <p style={{ textAlign: 'justify' }}>
              {getTranslatedString('landlordPortal.amenities.restrictions.hotZone.details')}
            </p>
            <div className="col-xs-6" style={{ paddingLeft: 0 }}>
              <Field
                name="max_number_of_bookings_in_hotzone"
                component={TextField}
                normalize={onlyNumbers}
                label={getTranslatedString(
                  'landlordPortal.amenities.restrictions.numberOfBookings'
                )}
                multiLine
                fullWidth
                style={{ fontSize: '15px' }}
                variant="outlined"
              />
            </div>
            <div className="col-xs-6" style={{ paddingRight: 0 }}>
              <Field
                name="booking_hotzone"
                component={OutlinedSelect}
                fullWidth
                variant="outlined"
                label={getTranslatedString(
                  'landlordPortal.amenities.restrictions.hotZone.hotSpotZone'
                )}
                style={{ fontSize: '14px' }}
              >
                <MenuItem value={'first_week'}>
                  {getTranslatedString('landlordPortal.amenities.restrictions.hotZone.firstWeek')}
                </MenuItem>
                <MenuItem value={'last_week'}>
                  {getTranslatedString('landlordPortal.amenities.restrictions.hotZone.lastWeek')}
                </MenuItem>
                <MenuItem value={'last_and_first_week'}>
                  {getTranslatedString(
                    'landlordPortal.amenities.restrictions.hotZone.lastAndFirstWeek'
                  )}
                </MenuItem>
              </Field>
            </div>
          </div>
          {this._renderAmenityTimesDay()}

          <Header
            name={getTranslatedString(
              'landlordPortal.amenities.restrictions.customizeBookingBufferTime'
            )}
          />
          <div className="row" style={{ padding: '15px' }}>
            <p style={{ textAlign: 'justify' }}>
              {getTranslatedString('landlordPortal.amenities.restrictions.bufferTimeDescription')}
            </p>
            <div className="col-xs-12" style={{ paddingLeft: 0 }}>
              {this._bufferFields(
                'booking_buffer_time_in_minutes',
                getTranslatedString('landlordPortal.amenities.restrictions.select')
              )}
            </div>
          </div>
          <div className="row" style={{ padding: '15px' }}>
            <p style={{ textAlign: 'justify' }}>
              {getTranslatedString(
                'landlordPortal.amenities.restrictions.bufferBetweenTimeDescription'
              )}
            </p>
            <div className="col-xs-12" style={{ paddingLeft: 0 }}>
              {this._bufferFields(
                'booking_buffer_time_between_in_minutes',
                getTranslatedString('landlordPortal.amenities.restrictions.select')
              )}
            </div>
          </div>
          <Header
            name={getTranslatedString(
              'landlordPortal.amenities.restrictions.setMaxAmountOfDailyBookingsUpcase'
            )}
          />
          <div className="row" style={{ padding: '15px' }}>
            <p style={{ textAlign: 'justify' }}>
              {getTranslatedString(
                'landlordPortal.amenities.restrictions.maxAmountOfDailyBookingsDescription'
              )}
            </p>
            <div className="col-xs-12" style={{ paddingLeft: 0 }}>
              <Field
                fullWidth
                name="max_number_of_daily_bookings"
                component={OutlinedSelect}
                label={getTranslatedString('landlordPortal.amenities.restrictions.select')}
                validate={[validator.required]}
              >
                <MenuItem key={`rest_max_bookings_options_0`} value="0">
                  {getTranslatedString('landlordPortal.amenities.restrictions.unlimited')}
                </MenuItem>
                {range(1, 13).map((i) => (
                  <MenuItem key={`rest_max_bookings_options_${i}`} value={i}>
                    {i} {getTranslatedString('landlordPortal.amenities.restrictions.times')}
                  </MenuItem>
                ))}
              </Field>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }

  _bufferFields = (fieldName, label) => (
    <Field
      fullWidth
      name={fieldName}
      component={OutlinedSelect}
      label={label}
      validate={[validator.required]}
    >
      <MenuItem key={`start_time_0`} value="0">
        {getTranslatedString('landlordPortal.amenities.restrictions.none')}
      </MenuItem>
      <MenuItem key={`start_time_30`} value="30">
        30 {getTranslatedString('landlordPortal.amenities.restrictions.minutes')}
      </MenuItem>
      <MenuItem key={`start_time_60`} value="60">
        1 {getTranslatedString('landlordPortal.amenities.restrictions.hour')}
      </MenuItem>
      <MenuItem key={`start_time_75`} value="75">
        75 {getTranslatedString('landlordPortal.amenities.restrictions.minutes')}
      </MenuItem>
      {this.getBufferTimes().map((i) => (
        <MenuItem key={`restriction_options_${i}`} value={i * 60}>
          {i} {getTranslatedString('landlordPortal.amenities.restrictions.hour')}s
        </MenuItem>
      ))}
    </Field>
  );

  _renderAmenityTimesDay = () => {
    if (!['day', 'night'].includes(this.props.amenity.amenity_duration_type)) return;
    const timeRange = createTimeRange();

    return (
      <Fragment>
        <Header
          name={getTranslatedString(
            'landlordPortal.amenities.restrictions.checkingTitle'
          ).toUpperCase()}
        />
        <div className="row" style={{ padding: '15px' }}>
          <p style={{ textAlign: 'justify' }}>
            {getTranslatedString('landlordPortal.amenities.restrictions.checkingTitle.details')}
          </p>
          <div className="col-xs-6" style={{ paddingLeft: 0 }}>
            <Field
              fullWidth
              name="check_in_time"
              component={OutlinedSelect}
              label={getTranslatedString(
                'landlordPortal.amenities.restrictions.checkingTitle.checkInTime'
              )}
              validate={[validator.required]}
            >
              {timeRange.map((option) => (
                <MenuItem key={`start_time_${option}`} value={option}>
                  {' '}
                  {option}{' '}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="col-xs-6" style={{ paddingRight: 0 }}>
            <Field
              fullWidth
              name="check_out_time"
              component={OutlinedSelect}
              label={getTranslatedString(
                'landlordPortal.amenities.restrictions.checkingTitle.checkOutTime'
              )}
              validate={[validator.required]}
            >
              {timeRange.map((option) => (
                <MenuItem key={`start_time_${option}`} value={option}>
                  {' '}
                  {option}{' '}
                </MenuItem>
              ))}
            </Field>
          </div>
        </div>
      </Fragment>
    );
  };

  getBufferTimes = () => {
    if (hostIsCapreit()) {
      return range(2, 25); // start at 2 as 1 hour option is already included
    }

    return [2, 4, 8, 12, 24];
  };
}

AmenityRestrictionsForm = compose(
  connect((store, ownProps) => {
    return {
      form: ownProps.formName,
    };
  }),
  reduxForm({
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
    enableReinitialize: true,
  })
)(AmenityRestrictionsForm);

export default AmenityRestrictionsForm;
